import Immutable from 'immutable'

export const ProductOptionRecord = Immutable.Record({
  id: null,
  dataKey: '',
  name: '',
  recurringPrice: 0,
  setupPrice: 0,
  skipContract: false,
}, 'ProductOption')

export default function createProductOption({
  ...data
}) {
  return new ProductOptionRecord({
    ...data
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/ProductOption.js